import { connect } from "@permaweb/aoconnect"
import { type Tag } from "arweave/web/lib/transaction"
import { useContext, useMemo } from "react"

import { ConfigContext, defaultConfig } from "../contexts/config"

export function useAo() {
  // config
  const [config] = useContext(ConfigContext)

  // ao instance
  const ao = useMemo(() => connect(config || defaultConfig), [config])

  return ao
}

export function useCachedAo() {
  // config
  const [config] = useContext(ConfigContext)

  // ao instance
  const ao = useMemo(() => {
    const cachedConfig = config || defaultConfig

    return connect({ ...cachedConfig, CU_URL: "https://cu-af.dataos.so" })
  }, [config])

  return ao
}

/**
 * ao connect() instance
 */
export type AoInstance = ReturnType<typeof connect>

/**
 * Returned message object(s) from dryRun
 */
export interface Message {
  Anchor: string
  Tags: Tag[]
  Target: string
  Data: string
}

export type { Tag }
